var debounce = require('../util/_debounce');

jQuery(function($) {
  $('.filter-reset').on('click', function(e) {
    filterReset();
    filter();
    offerUpdate();
    progTypeReset();
    $(this).hide();
    e.preventDefault();
    $('.current__filter__name').text('All Programs');
  });

  $('.filter-query').on('click', function(e) {
    window.location.hash = 'filter:' + $(this).attr('data-filter-query');

    $('.current__filter__name').text($(this).text());
    filter();
    offerUpdate();
    e.preventDefault();
  });

  // Filter Search
  $('.filter-query-input').on('propertychange change click keyup input paste', debounce(function(e) {
    var val = $(this).val();
    if (val) {
      window.location.hash = 'filter:' + val;
    } else {
      filterReset();
    }
    filter();
    offerUpdate();

  }, 500));

  $('.search__button').on('click', function(e) {
    e.preventDefault();
  });

  $(window).on('load hashchange', function() {
    filter();
    offerUpdate();
  });


  // Filter display "boxes"
  var filter = function() {
    var query = window.location.hash.substr(8).toLowerCase();

    $('.filter__display').each(function() {
      var display = $(this);
      var value = $(this).attr('data-filter');
      var check = value.toLowerCase().indexOf(query);
      if (check == -1) {
        display.addClass('filter__display--inactive');
      } else {
        display.removeClass('filter__display--inactive');
      }
    });



    $('.filter-reset').show();
  };

  // Filter link section
  var filterOnProgType = function() {
    var filterText = $(this).attr('data-filter-offering');

    $('.filter__options__link').removeClass('active');
    $(this).addClass('active');

    $('.filter__offerings__link').each(function(index, link) {
      if($(link).attr('data-filter-offering') == filterText || filterText == 'All Offerings') {
        $(link).removeClass('filter__offerings__link--disabled');
      }
      else {
        $(link).addClass('filter__offerings__link--disabled');
      }
    });

    $('.filter-reset').show();
  };

  $('.filter__options__link').click(filterOnProgType);

  var filterReset = function() {
    if (window.history && window.history.pushState) {
      window.history.pushState('', '', window.location.pathname);
    } else {
      window.location.hash = '';
    }
  };

  var progTypeReset = function() {
    $('.filter__offerings__link').removeClass('filter__offerings__link--disabled');
    $('.filter__options__link').removeClass('active');
    $('.filter__options__link').first().addClass('active');
  }

  var offerUpdate = function() {
    var offers = $('.filter__display:not(.filter__display--inactive)').length;
    $('.filter-count').html(offers + ' results');
  };




});
